import { ready } from './utils';
import { showMoreReviews } from './show-more';
import { cf7MaskTelValidation } from './cf7-mask-for-tel';
import { openFirstAccordion } from './accordions-pre-open';
import { bruniSliders } from './sliders';
import { bruniTabs } from './tabs';

ready(() => {
  cf7MaskTelValidation();
  showMoreReviews();
  openFirstAccordion();
  bruniSliders();
  bruniTabs();
});
